<template>
    <div class="form-group--border">
        <div class="row">
            <div class="col-12">
                <label class="control-label">Файл</label>
                <input type="file" id="file-input"
                       accept="application/xml"
                       class="form-control" v-on:change="fileChanged($event)">
                <div class="invalid-msg" v-if="v$.file.$error">Поле обязательно для заполнения</div>
            </div>
        </div>
        <div class="row">
            <div class="float-right d-flex align-items-center mt-4">
                <button-component class="btn btn-primary mx-2" v-on:click="doImport">Загрузить</button-component>
                <button-component type="button" kind="secondary" class="btn" v-on:click="close">Закрыть</button-component>
            </div>
        </div>
    </div>
</template>

<script>
  import ButtonComponent from "@/common/ui/ButtonComponent";
  import {useVuelidate} from "@vuelidate/core";
  import {required} from "@vuelidate/validators";
  export default {
    name: "ImportIpra",
    components: {ButtonComponent},
    emits: ['doimport', 'close'],
    data() {
      return {
        file: null
      }
    },
    methods: {
      fileChanged(e) {
        this.file = e.target.files[0];
      },
      doImport() {
        this.v$.$touch();
        if (this.v$.$invalid) {
          return;
        }
        this.$emit('doimport', this.file);
      },
      close() {
        this.$emit('close');
      }
    },
    setup: () => ({v$: useVuelidate()}),
    validations() {
      return {
        file: {required}
      }
    }
  }
</script>
